import { leadershipImgs, s3Bucket } from ".";

export const techArr = () => [
    {
        name: "Aleena Ashary",
        img: leadershipImgs.aleena,
        title: "Director of Product",
    },
    {
        name: "Naomi Provost ",
        img: leadershipImgs.naomi,
        title: "Head of Engineering",
    },
    {
        name: "Ryan Becwar",
        img: `${s3Bucket}rbecwar.jpg`,
        title: "Infrastructure Engineer",
    },
    {
        name: "Javiera Canales",
        img: `${s3Bucket}jcanales.jpeg`,
        title: "Data Engineer",
    },
    { name: "Xinbo Lu", img: `${s3Bucket}xlu.jpg`, title: "Software Engineer" },
];
